<ng-content />
<div #createBlock class="selection-area">
  <pr-interactive-timeline-drag-tooltip
    [summary]="summary$ | ngrxPush"
   />
</div>
